const NoRowsOverlay = () => {
  return (
    <div className='flex h-full items-center justify-center'>
      <span>
        Select a set of <b>Dimensions</b> and <b>Metrics</b> to see a row preview.
      </span>
    </div>
  );
};

export default NoRowsOverlay;
